import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from '../../../common/tooltip'
import { HandleDetail } from '../../common/handleDetail'
import { selectPeriod } from '../../common/period/slice'
import { CellTooltip } from './CellTooltip'
import { HighlightBorder } from './HighlightBorder'
import { getCellBgColor, getCellColor } from './helper'
import classes from './index.module.scss'
import { selectAnalyse, selectIsHighlight, selectVersus } from './store/slice'

export const Cell = ({ item, schema, rowIndex, colIndex, isDynamicReport }) => {
  const period = useSelector(selectPeriod)
  const analyse = useSelector(selectAnalyse)
  const versus = useSelector(selectVersus)
  const isHighlight = useSelector(selectIsHighlight) || isDynamicReport
  const params = { schema, rowIndex, colIndex }

  const [triggerShow, setTriggerShow] = useState(false)

  const onClickView = () => {
    setTriggerShow((prev) => !prev)
  }

  return (
    <div
      className="flex1 minW0 positionRelative"
      style={{
        color: getCellColor(params),
        backgroundColor: getCellBgColor(params),
      }}
    >
      <Tooltip
        tooltipContent={<CellTooltip {...item} onClickView={onClickView} />}
        isI18n={false}
        tooltipSpace={-12}
        contentClass={`${classes.p10} wh100 textEnd`}
      >
        <HandleDetail
          path="PortfolioInsights/PortfolioOverviewDetails"
          otherParams={{
            timeFrequency: period,
            analyse,
            versus,
            analyseId: [item.analyse.id],
            versusId: [item.versus.id],
          }}
          triggerShow={triggerShow}
          style={{ color: 'inherit' }}
        >
          {item.value}
        </HandleDetail>
      </Tooltip>
      {isHighlight && <HighlightBorder {...params} />}
    </div>
  )
}
